import React, { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const LayoutVariant = ({ children, data }) => {
  const [toggle, setToggle] = useState(false);
  const [expanded, setExpanded] = useState(false);

  return (
    <div>
      <Navbar
        toggle={toggle}
        setToggle={setToggle}
        expanded={expanded}
        setExpanded={setExpanded}
      />
      <main
        onClick={() => {
          setToggle(false);
        }}
      >
        {children}
      </main>
      <Footer data={data} />
    </div>
  );
};

export default LayoutVariant;
